module.exports = __webpack_public_path__ + "a10db08ca816dac8362bd9b6672f1456.jpg";